import i18n from '@opsbase/lib-i18n';
import IssueStatus from '@opsbase/lib-issue/IssueStatus';
import Palette from '@opsbase/lib-palette';
import useSelf from '@opsbase/react-ctrl-self/useSelf';
import { ConversationContainer } from '@opsbase/web-conversation-views';
import { useCss } from '@opsbase/web-css';
import Pane from '@opsbase/web-layout/Pane';
import React from 'react';
const makeMyClasses = () => ({
    root: {
        '& .ConversationView': {
            borderRadius: 0,
            borderColor: Palette.Platinum.main,
            backgroundColor: Palette.WhiteSmoke.main,
        },
        '& .PhotoTextInput, & .Callout': {
            backgroundColor: Palette.White.main,
        },
    },
});
export function IssueEditConversationPane({ issue }) {
    var _a;
    const self = useSelf();
    const myCss = useCss(makeMyClasses);
    return (!!(issue === null || issue === void 0 ? void 0 : issue.conversation) && (React.createElement(Pane, { grow: true, classes: { root: myCss.root } },
        React.createElement(ConversationContainer, { id: issue === null || issue === void 0 ? void 0 : issue.conversation.id, relatedIssueId: issue === null || issue === void 0 ? void 0 : issue.id, editable: !(self.isSuperUser || (issue === null || issue === void 0 ? void 0 : issue.status) === IssueStatus.CLOSED), activity: (_a = issue === null || issue === void 0 ? void 0 : issue.activity) !== null && _a !== void 0 ? _a : [], placeholderText: self.isSuperUser
                ? i18n.t('cannot-comment-superuser')
                : (issue === null || issue === void 0 ? void 0 : issue.status) === IssueStatus.CLOSED
                    ? i18n.t('cannot-comment-closed-issue')
                    : null }))));
}
export default IssueEditConversationPane;
